import { Dispatch } from "redux";
import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSliceNew";

export const handleSummaryClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.SFTP_SUMMARY_MODAL,
    }),
  );
};
